import type { AttributesEntity } from '@eliadmin/core/src/api/products/types/product-types';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export default function ProductVariantColor({ attribute }: { attribute: AttributesEntity }) {
  const selectedValues = useVariantsStore(state => state.selectedValues);
  const updateSelectedValue = useVariantsStore(state => state.updateSelectedValue);

  return (
    <div className={cn('flex', 'ea-product-detail-variant__color')}>
      {attribute.values?.map((value, i) => {
        const selected = selectedValues.some(
          selectedValue =>
            selectedValue.attribute.id === attribute.id && selectedValue.value.id === value.id,
        );
        return (
          <div
            key={`color-attribute-${i}`}
            className={cn(
              'flex flex-row items-center space-x-2',
              'ea-product-detail-variant__color-wrapper',
            )}
          >
            <div
              onClick={() => {
                updateSelectedValue({ attribute, value });
              }}
              className={cn(
                'mr-2 h-7 w-7 cursor-pointer rounded-full outline outline-1 outline-offset-2 outline-border',
                'ea-product-detail-variant__color-content',
                selected && 'outline-black',
              )}
              style={{ backgroundColor: value.color! }}
            />
            {/* <Label
              htmlFor={`attribute-${attribute.id}-value-${value.id}`}
              className={cn('', 'ea-product-detail-variant__color-label')}
            >
              {value.name}
            </Label> */}
          </div>
        );
      })}
    </div>
  );
}

// function groupByColors(variants: VariantsEntity[], values: ValuesEntity[]) {
//   const result: { value: ValuesEntity; images: string[] }[] = [];
//   for (const value of values) {
//     const images = new Set<string>();
//     for (const variant of variants) {
//       const exists = variant.values?.some(v => v.id === value.id);
//       if (exists && !!variant.images?.length) images.add(variant.images[0].url);
//     }
//     result.push({ value, images: [...images] });
//   }
//   return result;
// }
